import { API_CONFIG } from "./api";
import axios from "axios";
import { getTokenFromStorage } from "@/utils";

export const axiosInstance = axios.create({
  baseURL: API_CONFIG.SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

axiosInstance.interceptors.request.use(
  async config => {
    const token = getTokenFromStorage();

    if (token) {
      (config.headers as any).set('Authorization', `Bearer ${token}`);
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  },
)

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
)

export const axiosBitrixInstance = axios.create({
  baseURL: API_CONFIG.BITRIX_URL
})

axiosBitrixInstance.interceptors.request.use(
  async config => {
    const credentials = `${API_CONFIG.BITRIX_USERNAME}:${API_CONFIG.BITRIX_PASSWORD}`;
    const token = btoa(credentials);
    if (config.headers) {
      (config.headers as any).Authorization = `Basic ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error)
  }
);

axiosBitrixInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);